'use client';

import { ChangeEvent, useState } from 'react';

import { useTranslations } from 'next-intl';

import usePaymentFormContext from 'hooks/usePaymentFormContext';
import useUser from 'hooks/useUser';
import ChoiceInput from 'ui/ChoiceInput';
import Input from 'ui/Input';

const AddBusinessInformation = () => {
  const tCheckout = useTranslations('checkout');

  const { user } = useUser();

  const {
    memberCompanyInfo,
    memberCompanyInfoErrors,
    onChangeMemberAsCompany,
    onChangeMemberCompanyInfo,
  } = usePaymentFormContext();

  const [shouldPurchaseAsBusiness, setShouldPurchaseAsBusiness] = useState(
    memberCompanyInfo.isCompany,
  );

  const handleChangePurchaseAsBusiness = (e: ChangeEvent<HTMLInputElement>) => {
    setShouldPurchaseAsBusiness(e.target.checked);
    onChangeMemberAsCompany(e.target.checked);
  };

  // If user is logged in and all of the company data is filled, the input should be disabled
  const isAllCompanyDataFilled = user?.companyName && user?.organizationNo;
  const shouldDisableInput = user && isAllCompanyDataFilled ? true : false;

  const isShouldPurchaseAsBusinessDisabled = user ? true : false;

  return (
    <>
      <div className="sm:col-span-6 flex flex-col gap-y-2">
        <div className="flex-1 text-base text-darkBlue">
          <ChoiceInput
            id="shouldPurchaseAsBusiness"
            name="shouldPurchaseAsBusiness"
            label={tCheckout('purchasingAsBusinessLabel')}
            checked={shouldPurchaseAsBusiness}
            isDisabled={isShouldPurchaseAsBusinessDisabled}
            type="checkbox"
            color="black"
            blurOnDisabled={false}
            labelTextSize="text-base"
            onChange={handleChangePurchaseAsBusiness}
          />
        </div>
      </div>
      {shouldPurchaseAsBusiness && (
        <div className="sm:col-span-6 gap-y-5 flex flex-col">
          <div className="flex flex-col gap-y-1">
            <label className="font-bold text-sm">
              {tCheckout('companyName').toLocaleUpperCase()}
            </label>
            <Input
              type="text"
              name="companyName"
              id="companyName"
              placeholder={tCheckout('companyNamePlaceholder')}
              value={memberCompanyInfo.companyName || ''}
              disabled={shouldDisableInput}
              isReadOnly={shouldDisableInput}
              onChange={onChangeMemberCompanyInfo}
              errorMessage={memberCompanyInfoErrors.companyName}
            />
          </div>
          <div className="flex flex-col gap-y-1">
            <label className="font-bold text-sm">
              {tCheckout('orgNumber').toLocaleUpperCase()}
            </label>
            <Input
              type="text"
              name="organizationNo"
              id="organizationNo"
              placeholder={tCheckout('orgNumberPlaceholder')}
              value={memberCompanyInfo.organizationNo || ''}
              disabled={shouldDisableInput}
              isReadOnly={shouldDisableInput}
              onChange={onChangeMemberCompanyInfo}
              errorMessage={memberCompanyInfoErrors.organizationNo}
            />
          </div>
        </div>
      )}
    </>
  );
};

export default AddBusinessInformation;
